import React from "react";
import "./role-feature-mapping-master.styles.css";
import { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserData,selectMSMessageRBAC } from "../../redux/user/user.selectors";
import { canUserEdit,getUserMSRBACMessage } from "../../auth/utils";
import { FeatureCodes } from "../../auth/data";
import {
  Table,
  Spin,
  Input,
  Select,
  Button,
  message,
  Form,
  Modal,
  Radio,
} from "antd";

import API from "../../api";
const { Search } = Input;
const { Option } = Select;
/**
 * @description Component for user management tab
 *
 * @component
 */
class RoleFeatureMaster extends Component {
  state = {
    isModalVisible: false,
    isAdd: false,
    currentRecord: null,
    userBranches: null,
    searchText: null,
    searchUserType: 0,
    roleFeatureTableData: [],
    featureList: [],
    mandiRegionList: [],
    roleList: [],
    hubRegionList: [],
    hubBranchList: [],
    isSpinnerOnLoad: false,
    isSubmitted: false,
    newData: {
      is_active: true,
      location_access: true,
      non_location_access: true,
      role_feature_id: undefined,
      role_features: undefined,
      role_id: undefined,
      role_name: "",
      role_feature: "",
      isEdit: false,
      feature_id: undefined
    },
    rowData: undefined,
    selectedRoleValue: undefined,
    selectedRoleName: "",
    selectedRoleList: [],
  };
  componentDidMount() {
    this.setState({ isSpinnerOnLoad: true });
    this.getRoleList();
    this.getFeatureList();
  }

  getRoleList = async () => {
    this.setState({ isSpinnerOnLoad: true });

    //TODO: change api
    await API.get("/user_role")
      .then((roleData) => {
        this.setState(
          {
            roleList: roleData.data.data,
          },
          () => this.getRoleMaster()
        );
      })
      .catch((err) => {
        if (err) {
          if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
        this.setState({ isSpinnerOnLoad: false });
      });
  };

  getFeatureList = async () => {

    //TODO: change api
    await API.get("/list_feature")
      .then((roleData) => {
        this.setState(
          {
            featureList: roleData.data.data,
          },
        );
      })
      .catch((err) => {
        if (err) {
          if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
        this.setState({ isSpinnerOnLoad: false });
      });
  };

  getRoleMaster = async () => {
    this.setState({ isSpinnerOnLoad: true });


    await API.get("/master_role_feature_map")
      .then((varietyResponse) => {

        varietyResponse.data.data.map((dataDetailItem, index) => {
          dataDetailItem.key = index;
          dataDetailItem.isEdit = false;
        });
        this.setState(
          {
            // roleFeatureTableData: [],
            roleFeatureTableData: varietyResponse.data.data,
          },
          () => this.setState({ isSpinnerOnLoad: false, isAdd: true })
        );

      })
      .catch((err) => {
        if (err) {
          if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
        this.setState({ isSpinnerOnLoad: false });
      });
  };

  setTableData = () => {
    if (this.state.roleFeatureTableData !== undefined || this.state.roleFeatureTableData.length >= 0) {
      const userTableData = this.state.roleFeatureTableData.map((user, index) => {
        return {
          key: user.key,
          is_active: user.is_active,
          location_access: user.location_access,
          non_location_access: user.non_location_access,
          role_feature_id: user.role_feature_id,
          role_features: user.role_features,
          role_id: user.role_id,
          role_name: user.role_name,
          role_feature: user.role_feature,
          isEdit: user.isEdit,
          feature_id: user.feature_id,
        };
      });

      let dataAfterSearch = userTableData;

      if (this.state.searchText) {
        dataAfterSearch = dataAfterSearch.filter(
          (item) =>
            (item.role_name !== null &&
              item.role_name
                .toLowerCase()
                .includes(this.state.searchText.toLowerCase())) ||
            (item.role_feature !== null &&
              item.role_feature
                .toLowerCase()
                .includes(this.state.searchText.toLowerCase()))
          // (item.hub_name !== null &&
          //   item.hub_name
          //     .toLowerCase()
          //     .includes(this.state.searchText.toLowerCase())) 
        );
      }

      return dataAfterSearch;
    }
    else {
      return this.state.roleFeatureTableData;
    }
  };

  submitTableRowData = (row, index, isPopup) => {
    this.setState({ isSpinnerOnLoad: true, isSubmitted: true });
    let warningmessage = "";
    if (row.role_name === null || row.role_name === undefined || row.role_name === "") {
      warningmessage = "Please select role";
    }
    else if (row.role_feature === null || row.role_feature === undefined || row.role_feature === "") {
      warningmessage = "Please select feature";
    }

    if (
      warningmessage === "" ||
      warningmessage === undefined ||
      warningmessage === null
    ) {
      this.setState({ isSpinnerOnLoad: true });
      this.setState({ isSubmitted: true })
      let data = {
        is_active: row.is_active,
        location_access: row.location_access,
        non_location_access: row.non_location_access,
        role_feature_id: row.role_feature_id,
        role_features: row.role_features,
        role_id: row.role_id,
        role_name: row.role_name,
        role_feature: row.role_feature,
        feature_id: row.feature_id,
      };



      API.put("/master_role_feature_map", data, {

      })
        .then((response) => {
          if (response.status === 200 && response.data.status) {
            message.info(response.data.message, 5);
            this.setModalVisibility(false);
            this.getRoleMaster();
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
          } else if (!response.data.status) {
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
            message.error(response.data.message, 5);
            // this.setModalVisibility(false);
          } else {
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
            message.error("Please try again", 5);
          }
        })
        .catch((err) => {
          if (err) {
            if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
            else {
              message.error("Something went wrong.. Please try again later.", 5);
            }
          } else {
            message.error("Something went wrong... Please try again later.", 5);
          }
          this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
          // this.setModalVisibility(false);
        });
    } else {
      this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
      message.error(warningmessage, 5);
    }
  };

  setModalVisibility = (status) => {
    if (status) {
      const nData = {
        is_active: true,
        location_access: true,
        non_location_access: true,
        role_feature_id: undefined,
        role_features: undefined,
        role_id: undefined,
        role_name: "",
        role_feature: "",
        isEdit: false,
        feature_id: undefined
      };

      this.setState({ newData: nData });
    }

    this.setState({ isModalVisible: status });
  };

  TableColumnHeader = (props) => {
    const { title, subtitle } = props;
    return (
      <div className="column-header-container">
        <div
          style={{
            color: "white",
            fontSize: "12px",
            whiteSpace: "nowrap",
            fontWeight: "normal",
            textAlign: "left",
          }}
        >
          {title}
        </div>
        <div
          style={{
            color: "#cbdfff",
            fontSize: "11px",
            fontWeight: "normal",
            textAlign: "left",
            // subtitle && title.length < subtitle.length ? "left" : "center"
          }}
        >
          {subtitle}
        </div>
      </div>
    );
  };

  createFilters = (label) => {
    let filterData = this.state.roleFeatureTableData;
    //#region remove duplicate objects
    let uniqueFilterData = [];

    if (label === "is_active" && this.state.roleFeatureTableData && this.state.roleFeatureTableData.length > 0) {
      uniqueFilterData = [{ text: "Yes", value: 1 }, { text: "No", value: 0 }]
    }
    else {
      filterData.map((mainItem) =>
        uniqueFilterData.filter((item) => item[label] === mainItem[label])
          .length > 0
          ? null
          : uniqueFilterData.push(mainItem)
      );

      uniqueFilterData = uniqueFilterData.map((item) => {
        return {
          text: item[label],
          value: item[label],
        };

      });

      uniqueFilterData.sort((a, b) => a.text.localeCompare(b.text))
    }

    return uniqueFilterData;
  };

  handleChange = (e, row, index, name, isPopup) => {
    e.target.name = name;

    var alphaNumericRegex = /^[a-zA-Z0-9]*$/;
    var numberRegex = /^[0-9.]+$/;

    let a;
    if (isPopup === false) {
      a = this.state.roleFeatureTableData;

      //   if (e.target.name === "M_H_Freight") {
      //     if (e.target.value === "") {
      //       a[row.key].M_H_Freight = "";
      //     } else if (e.target.value.match(numberRegex)) {
      //       a[row.key].M_H_Freight = e.target.value;
      //     }
      //   }

      this.setState({ roleFeatureTableData: a });
    } else {
      a = this.state.newData;

      //   if (
      //     e.target.name === "M_H_Freight") {
      //     if (e.target.value === "") {
      //       a.M_H_Freight = "";
      //     } else if (e.target.value.match(numberRegex)) {
      //       a.M_H_Freight = e.target.value;
      //     }
      //   }

      this.setState({ newData: a });
    }
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  handleEditChange = (row, index) => {
    this.setState({ rowData: row });
    let tempData = this.state.roleFeatureTableData.map((item) => {

      if (item.key === row.key) {
        return {
          ...item,
          isEdit: true
        }
      } else {
        return item;
      }
    })
    this.setState({ roleFeatureTableData: tempData });
  };

  handleCancelClick = (rowData, index) => {
    let tempData = this.state.roleFeatureTableData.map((item) => {
      if (item.key === rowData.key) {
        return this.state.rowData
      } else {
        return item;
      }
    })
    this.setState({ roleFeatureTableData: tempData });
  };

  handleDropdownChange = (value, row, target, index, optionlabel, isPopup) => {

    let a;

    if (isPopup === false) {
      a = this.state.roleFeatureTableData;

      if (target === "is_active") {
        a[row.key].is_active = Boolean(value);
      }
      else if (target === "location_access") {
        a[row.key].location_access = Boolean(value);
      }
      else if (target === "non_location_access") {
        a[row.key].non_location_access = Boolean(value);
      }
      else if (target === "role_name") {
        a[row.key].role_name = optionlabel;
        a[row.key].role_id = value;
      }
      else if (target === "role_feature") {
        a[row.key].feature_id = value;
        a[row.key].role_feature = optionlabel;
      }

      this.setState({ roleFeatureTableData: a });
    } else {
      a = this.state.newData;

      if (target === "is_active") {
        a.is_active = Boolean(value);
      }
      else if (target === "location_access") {
        a.location_access = Boolean(value);
      }
      else if (target === "non_location_access") {
        a.non_location_access = Boolean(value);
      }
      else if (target === "role_name") {
        a.role_name = optionlabel;
        a.role_id = value;
      }
      else if (target === "role_feature") {
        a.feature_id = value;
        a.role_feature = optionlabel;
      }

      this.setState({ newData: a });
    }
  };

  render() {
    const userTableProps = {
      pagination: false,
      size: "default",
      bordered: true,
      scroll: { x: 200, y: window.innerHeight - 250 },
    };

    const handleRoleSelect = (value, props) => {
      this.setState(
        { selectedRoleName: props.key, selectedRoleValue: value },
        () => this.getRoleMaster()
      );
    };

    return (
      <div
        className="mandi-master-container"
        style={{
          height: window.innerHeight - 85,
          marginTop: "-45px",
        }}
      >
        <div className="top-container">
          {/*
      <div className="hub-region-filter">

      
      <span
      style={{
        fontSize: "15px",
        marginTop: "5px",
        fontWeight: "600",
        marginLeft: "30px",
      }}
    >
     Region&nbsp;
    </span>{" "}
    <Select
    disabled={!this.state.isAdd}
    showSearch
    optionFilterProp="children"
    className={"select-master-region"}
    mode="single"
    placeholder="Select Region"
    value={this.state.selectedRegionValue}
    onChange={(value, props) =>
      handleRoleSelect(value, props)
    }
  >
    {this.state.selectedRoleList !== null && this.state.selectedRoleList.length &&
      this.state.selectedRoleList.map((item, idx) => (
        <Option
          value={item.role_id}
          key={item.role_name}
        >
          {item.role_name}
        </Option>
      ))}
  </Select>
 
      </div>
      */}

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row-reverse",
              placeItems: "flex-end",
              marginRight: "25px",
              marginBottom: "10px",
            }}
          >
            <Search
              disabled={!this.state.isAdd}
              placeholder="Search"
              allowClear
              onChange={(e) => this.setState({ searchText: e.target.value })}
              style={{ width: "25%" }}
            />
            <Button
              className="add-master-button"
              style={{
                height: "25px",
                width: "70px",
                backgroundColor: "#0b133d",
                color: "white",
              }}
              disabled={!canUserEdit(
                this.props.userData,
                null,
                FeatureCodes.MS_ROLE_FEATURE_MAP_EDIT
              ) || !this.state.isAdd}
              onClick={() => this.setModalVisibility(true)}
            >
              &#10010; Add
            </Button>
          </div>
        </div>

        <div>
        <div
        style={{
          marginLeft: "25px",
          marginTop: "-8px",
          fontSize: "14px",
          color: "red",
          display: "flex",
          float: "left",
        }}
      > {getUserMSRBACMessage(this.props.messageAccess,FeatureCodes.MS_ROLE_FEATURE_MAP_EDIT)}
      </div>
        <div
          style={{
            marginRight: "20px",
            marginTop: "-8px",
            fontSize: "15px",
            color: "#0B133D",
            display: "flex",
            float: "right",
          }}
        >Total number of records:&nbsp;
          <b>{this.state.roleFeatureTableData && this.setTableData().length}</b>
        </div>
</div>

        <Spin
          spinning={this.state.isSpinnerOnLoad}
          size={"large"}
          tip="Loading..."
          style={{ alignSelf: "center", zIndex: 9999, marginTop: "20px" }}
        >
          <Modal
            className="add-master-modal"
            title={"Add Role feature mapping"}
            onCancel={this.handleCancel}
            footer={false}
            visible={this.state.isModalVisible}
            destroyOnClose={true}
          >
            <div className="master-form-container">
              <Form
                layout="horizontal"
                //   onValuesChange={onFormLayoutChange}
                size={"small"}
              // onSubmit={submitTableRowData(this.state.newData)}
              >
                <div className="form-top-container1">
                  <div
                    className="checkbox-group1"
                    style={{
                      display: "inline-block",
                      width: "55%",
                      marginRight: 40,
                    }}
                  >
                    <Form.Item label="Role">
                      <Select
                        showSearch
                        optionFilterProp="children"
                        className="remarks-select"
                        name="role_name"
                        defaultValue={this.state.newData.role_name}
                        value={this.state.newData.role_name}
                        onSelect={(value, option) =>
                          this.handleDropdownChange(
                            value,
                            this.state.newData,
                            "role_name",
                            -0,
                            option.props.children,
                            true
                          )
                        }
                      >
                        {this.state.roleList &&
                          this.state.roleList.length &&
                          this.state.roleList.map((hubItem, idx) => (
                            <Option
                              key={hubItem.role_id}
                              value={hubItem.role_id}
                            >
                              {hubItem.role_name}
                            </Option>
                          ))}
                      </Select>

                    </Form.Item>
                  </div>
                  <div
                    className="checkbox-group1"
                    style={{
                      display: "inline-block",
                      minWidth: "55%",
                      marginRight: 40,
                    }}
                  >
                    <Form.Item label="Feature">
                      <Select
                        showSearch
                        optionFilterProp="children"
                        className="remarks-select"
                        name="role_feature"
                        defaultValue={this.state.newData.role_feature}
                        value={this.state.newData.role_feature}
                        onSelect={(value, option) =>
                          this.handleDropdownChange(
                            value,
                            this.state.newData,
                            "role_feature",
                            -0,
                            option.props.children,
                            true
                          )
                        }
                      >
                        {this.state.featureList &&
                          this.state.featureList.length &&
                          this.state.featureList.map((hubItem, idx) => (
                            <Option
                              key={hubItem.feature_id}
                              value={hubItem.feature_id}
                            >
                              {hubItem.feature_code + "-" + hubItem.feature_desc}
                            </Option>
                          ))}
                      </Select>

                    </Form.Item>

                  </div>
                </div>

                <div className="form-top-container1">
                  <hr />

                  <div
                    className="form-top-container"
                    style={{
                      display: "inline-block",
                      width: "40%",
                      marginRight: 7,
                    }}
                  >
                    <Form.Item label="Location access">
                      <Radio.Group
                        name="location_access"
                        value={this.state.newData.location_access ? 1 : 0}
                        onChange={(e, option) =>
                          this.handleDropdownChange(
                            e.target.value,
                            this.state.newData,
                            "location_access",
                            -0,
                            "",
                            true
                          )
                        }
                      >
                        <Radio value={1}>Yes</Radio>
                        <Radio value={0}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                  <div
                    className="form-top-container"
                    style={{
                      display: "inline-block",
                      width: "40%",
                      marginRight: 7,
                    }}
                  >
                    <Form.Item label="Non-location access">
                      <Radio.Group
                        name="non_location_access"
                        value={this.state.newData.non_location_access ? 1 : 0}
                        onChange={(e, option) =>
                          this.handleDropdownChange(
                            e.target.value,
                            this.state.newData,
                            "non_location_access",
                            -0,
                            "",
                            true
                          )
                        }
                      >
                        <Radio value={1}>Yes</Radio>
                        <Radio value={0}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>


                  <div
                    className="form-top-container"
                    style={{
                      display: "inline-block",
                      width: "40%",
                      marginRight: 7,
                    }}
                  >
                    <Form.Item label="Active">
                      <Radio.Group
                        name="is_active"
                        value={this.state.newData.is_active ? 1 : 0}
                        onChange={(e, option) =>
                          this.handleDropdownChange(
                            e.target.value,
                            this.state.newData,
                            "is_active",
                            -0,
                            "",
                            true
                          )
                        }
                      >
                        <Radio value={1}>Yes</Radio>
                        <Radio value={0}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>

                </div>


                <div className="form-bottom-container">
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={this.state.isSubmitted}
                      onClick={() =>
                        this.submitTableRowData(this.state.newData, 0, true)
                      }
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </div>
          </Modal>


          <div className="table-container1" style={{ maxHeight: "450px", width: "99%", margin: "6px 0px" }}>
            <Table
              {...userTableProps}
              columns={[
                {
                  key: "role_name",
                  title: "Role",
                  dataIndex: "role_name",
                  width: 80,
                  filters: this.createFilters("role_name"),
                  onFilter: (value, record) => record.role_name.includes(value),
                  sortDirections: ["descend", "ascend"],
                  sorter: (a, b) => a.role_name.localeCompare(b.role_name),
                },
                {
                  key: "role_feature",
                  title: "Feature",
                  dataIndex: "role_feature",
                  width: 120,
                  filters: this.createFilters("role_feature"),
                  onFilter: (value, record) => record.role_feature.includes(value),
                  sortDirections: ["descend", "ascend"],
                  sorter: (a, b) => a.role_feature.localeCompare(b.role_feature),
                },
                {
                  key: "location_access",
                  title: "Location Access",
                  dataIndex: "location_access",
                  width: 50,
                  // filters: [
                  //   { text: "Yes", value: 1 },
                  //   { text: "No", value: 0 },
                  // ],
                  // onFilter: (value, record) => record.is_active.includes(value),
                  render: (record, rowRecord, index) => {
                    return (
                      <>
                        <div style={{ marginLeft: "-15px", marginRight: "-40px" }}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            disabled={!rowRecord.isEdit}
                            defaultValue={
                              rowRecord.location_access === true ? "Yes" : "No"
                            }
                            value={
                              rowRecord.location_access === true ? "Yes" : "No"
                            }
                            onChange={(value, option) =>
                              this.handleDropdownChange(
                                value,
                                rowRecord,
                                "location_access",
                                index,
                                option.props.children,
                                false
                              )
                            }
                            style={{ width: "70%" }}
                          >
                            <Option key={1} value={1}>
                              {"Yes"}
                            </Option>
                            <Option key={0} value={0}>
                              {"No"}
                            </Option>
                          </Select>
                        </div>
                      </>
                    );
                  },
                },
                {
                  key: "non_location_access",
                  title: "Non-Location Access",
                  dataIndex: "non_location_access",
                  width: 50,
                  // filters: [
                  //   { text: "Yes", value: 1 },
                  //   { text: "No", value: 0 },
                  // ],
                  // onFilter: (value, record) => record.non_location_access.includes(value),
                  render: (record, rowRecord, index) => {
                    return (
                      <>
                        <div style={{ marginLeft: "-15px", marginRight: "-40px" }}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            disabled={!rowRecord.isEdit}
                            defaultValue={
                              rowRecord.non_location_access === true ? "Yes" : "No"
                            }
                            value={
                              rowRecord.non_location_access === true ? "Yes" : "No"
                            }
                            onChange={(value, option) =>
                              this.handleDropdownChange(
                                value,
                                rowRecord,
                                "non_location_access",
                                index,
                                option.props.children,
                                false
                              )
                            }
                            style={{ width: "70%" }}
                          >
                            <Option key={1} value={1}>
                              {"Yes"}
                            </Option>
                            <Option key={0} value={0}>
                              {"No"}
                            </Option>
                          </Select>
                        </div>
                      </>
                    );
                  },
                },
                {
                  key: "is_active",
                  title: "Active",
                  dataIndex: "is_active",
                  width: 50,
                  filters: this.createFilters("is_active"),
                  // filters: [{ text: "Yes", value: 1 }, { text: "No", value: 0 }],
                  onFilter: (value, record) =>
                    record.is_active === Boolean(value),
                  render: (record, rowRecord, index) => {
                    return (
                      <>
                        <div style={{ marginLeft: "-15px", marginRight: "-40px" }}>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            disabled={!rowRecord.isEdit}
                            defaultValue={
                              rowRecord.is_active === true ? "Yes" : "No"
                            }
                            value={
                              rowRecord.is_active === true ? "Yes" : "No"
                            }
                            onChange={(value, option) =>
                              this.handleDropdownChange(
                                value,
                                rowRecord,
                                "is_active",
                                index,
                                option.props.children,
                                false
                              )
                            }
                            style={{ width: "70%" }}
                          >
                            <Option key={1} value={1}>
                              {"Yes"}
                            </Option>
                            <Option key={0} value={0}>
                              {"No"}
                            </Option>
                          </Select>
                        </div>
                      </>
                    );
                  },
                },

                {
                  title: "Action",
                  dataIndex: "Submit",
                  key: "Submit",
                  width: 90,
                  visibility: false,
                  render: (record, rowRecord, index) => {
                    return (
                      <>
                        <div style={{ display: "inline-flex", width: "100%" }}>
                          <Button
                            // className={
                            //   rowRecord.surplus_deficit <= 0
                            //     ? "disable-edit-btn"
                            //     : "edit-btn"
                            // }
                            className={!canUserEdit(
                              this.props.userData,
                              null,
                              FeatureCodes.MS_ROLE_FEATURE_MAP_EDIT
                            ) ? "disabledBtnClass" : "btnClass"}
                            disabled={!canUserEdit(
                              this.props.userData,
                              null,
                              FeatureCodes.MS_ROLE_FEATURE_MAP_EDIT
                            )}
                            type="primary"
                            size={"small"}
                            style={{
                              marginLeft: 5,
                              alignSelf: "center",
                              padding: "0px 0px 2px",
                              height: 31,
                              backgroundColor: "#20346a",
                              color: "white",
                              borderRadius: 15,
                            }}
                            block
                            htmlType="submit"
                            onClick={() =>
                              rowRecord.isEdit
                                ? this.submitTableRowData(rowRecord, index, false)
                                : this.handleEditChange(rowRecord, index)
                            }
                          >
                            {" "}
                            {rowRecord.isEdit ? "Submit" : "Edit"}{" "}
                          </Button>


                          <Button
                            className={!rowRecord.isEdit ? "disabledBtnClass" : "btnClass"}
                            type="primary"
                            size={"small"}
                            style={{
                              marginLeft: 5,
                              alignSelf: "center",
                              color: "white",
                              borderRadius: 15,
                              padding: "0px 0px 2px",
                              height: 31,
                              backgroundColor: "#20346a",
                            }}
                            block
                            htmlType="submit"
                            disabled={!rowRecord.isEdit}
                            onClick={() => this.handleCancelClick(rowRecord, index)
                            }
                          >
                            Cancel
                          </Button>

                        </div>
                      </>
                    );
                  },
                },
              ]}
              dataSource={this.setTableData()}
            />
          </div>

        </Spin>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  messageAccess: selectMSMessageRBAC,
});
export default connect(mapStateToProps)(RoleFeatureMaster);
//export default RoleFeatureMaster;
